import { Invoice } from '../../services/invoice.model';
import { TbasService } from '../../services/tbas.services';
import { OtpService } from '../../services/otp.service';
import GlobalSpinnerService from '../../../common/services/spinner/global-spinner.service';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { OtpAction } from '../../../no-auth/components/otp-dialog/otp-dialog.action';
import HttpService from '../../../common/services/http.service';
import { IHttpService } from 'angular';
import NoAuthService from '../../../no-auth/services/noauth.service';
import {
  PaymentProgressChangeAction,
  PaymentProgressStatus
} from '../../../components/payment-progress/payment-progress.action';
import UserService from '../../../common/services/user/user.service';
import { UserResponse } from '../../../common/services/user/user.model';
import { BillInfoChangeAction } from '../bill-info.action';
import UtilService from '../../../common/services/util.service';
import { Address } from '../../../common/models/address.model';
import { UserListeningPackagesResponse } from '../../../common/services/package/package.model';
import PackageService from '../../../common/services/package/package.service';

/* @ngInject */
export default class BillInfoAddController {
  private invoice: Invoice;
  private user: UserResponse;
  private packages: UserListeningPackagesResponse;

  private cities: any[];
  private towns: any[];
  private selectedCity: number;
  private validation: boolean;
  private promocode: string;
  private msisdnError: boolean = false;
  public msisdnValid: boolean = false;
  public msisdnInput: string = '';

  constructor(
    private config,
    private $state,
    private $q,
    private $scope,
    private $http: IHttpService,
    private globalSpinner: GlobalSpinnerService,
    private tbasService: TbasService,
    private actionDispatcher: ActionDispatcherService,
    private userService: UserService,
    private packageService: PackageService,
    private httpService: HttpService,
    private noAuthService: NoAuthService,
    private otpService: OtpService
  ) {
    this.userService.getUserInfo().then(user => {
      this.user = user;
      // Phone field is not shown in the form anymore, but the msisdn must still
      // be submitted with the invoice.
      if (this.invoice) {
        this.invoice.msisdn = user.msisdn;
      }
    });
    this.packageService
      .getUserListeningPackages()
      .then(result => (this.packages = result));

    // Override NoAuthService.validateOTP for updateMsisdn flow
    this.noAuthService.validateOTP = (msisdn: string, smsCode: string) => {
      return this.otpService.validateOTP(msisdn, smsCode);
    };
  }

  public $onInit() {
    if (this.user) {
      this.checkMsisdnValidity();
    } else {
      this.userService.getUserInfo().then(user => {
        this.user = user;
        this.checkMsisdnValidity();
      });
    }
  }

  private checkMsisdnValidity() {
    if (this.user && this.user.msisdn) {
      const msisdn = String(this.user.msisdn);
      if (msisdn.charAt(0) === "5" && msisdn.length === 10) {
        this.msisdnValid = true;
      } else {
        this.msisdnValid = false;
      }
    }
  }

  private showMsisdnError() {
    const msisdnField = document.getElementById("msisdnFieldBillInfo");
    if (msisdnField) {
      msisdnField.classList.add("form-field--error");
    }
    this.msisdnError = true;
  }

  private hideMsisdnError() {
    const msisdnField = document.getElementById("msisdnFieldBillInfo");
    if (msisdnField) {
      msisdnField.classList.remove("form-field--error");
    }
    this.msisdnError = false;
  }

  public sendOTP() {
    if (this.checkMsisdnField()) {
      this.globalSpinner.startIfNotActivated();
      const tmpMsisdn = this.getMsisdn();
      this.otpService.sendOTP(tmpMsisdn).then(result => {
        if (result) {
          this.actionDispatcher.dispatch(new OtpAction(tmpMsisdn, () => this.afterValidationMsisdn(tmpMsisdn)));
        }
        this.globalSpinner.stop();
      }).catch(() => {
        this.globalSpinner.stop();
      });
    }
  }

  private checkMsisdnField(): boolean {
    const msisdn = this.getMsisdn();
    if (msisdn.charAt(0) === "5" && msisdn.length === 10) {
      this.hideMsisdnError();
      return true;
    }
    this.showMsisdnError();
    return false;
  }

  private getMsisdn(): string {
    return String(this.msisdnInput);
  }

  private afterValidationMsisdn(msisdn: string) {
    this.globalSpinner.startIfNotActivated();
    this.user.msisdn = msisdn;
    this.msisdnValid = true;
    this.globalSpinner.stop();
  }

  public overlayClick() {
    this.showMsisdnError();
    const msisdnInput = document.getElementById("msisdnBillInfo") as HTMLInputElement;
    if (msisdnInput) {
      msisdnInput.focus();
    }
    window.scrollTo(0, 0);
  }

  public isMsisdnValid(): boolean {
    return this.msisdnValid;
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/bill-info/add/bill-info-add.controller.ts